._iconWrapper_jjlky_1 {
  border-radius: 8px;
  box-shadow: 0 0 9px 1px rgba(0, 0, 0, 0.1);
  border: 5px solid #fff;
  background-size: cover;
  background-position: center;
  height: 60px;
  width: 60px;
  margin-left: 7px; }

._icon_jjlky_1 {
  width: 100%;
  height: 100%;
  background-size: contain;
  border-radius: 5px; }
